










import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import { Vue, Component, Prop } from 'vue-property-decorator'
import SeletorDeLojas from './SeletorDeLojas.vue'

@Component({
	components: {
		SeletorDeLojas,
	},
})
export default class SeletorDeLojasDoUsuario extends Vue {
	@Prop({ type: Boolean, default: false }) disableSeletorDeLojas!: boolean;
	@Prop({ type: String, default: null }) grupoEconomicoId!: string | null;

	get possuiAcessoIrrestrito() {
		return UserLoginStore.permiteRegraDeNegocio('acesso-irrestrito')
	}

	get idUsuarioLogado(): string | undefined {
		return UserLoginStore.usuario?.id || undefined
	}
}
